import React, { useState } from "react";
import classes from "./ToolTip.module.css";
import { Tooltip } from "@mui/material";

const ToolTip = ({ tooltipText }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Tooltip 
      title={tooltipText}
      open={isOpen}
      onClose={() => setIsOpen(false)}
      onClick={() => setIsOpen(!isOpen)}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      sx={{
        '& .MuiTooltip-tooltip': {
          backgroundColor: 'white',
          color: '#64615D',
          border: '1px solid rgba(0, 0, 0, 0.1)',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
          padding: '5px 10px',
          fontFamily: 'Fraunces',
          fontSize: '14px',
          maxWidth: 200
        }
      }}
    >
      <div className={classes.infoIcon}>
        i
      </div>
    </Tooltip>
  );
}

export default ToolTip;
